import React from 'react';

interface Props {
  style?: object;
  onClick?: () => void;
  color?: string;
}

export default function IconClose({ style, onClick, color = '#00391E' }: Props) {
  return (
    <svg
      role="close-icon"
      className="close-icon"
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
      onClick={onClick}
    >
      <path
        d="M1.64226 0L0.0524126 1.59383L8.91015 10.4737L0 19.4237L1.57238 21L10.5 12.0676L19.4101 21L21 19.4062L12.0898 10.4737L20.9476 1.59383L19.3577 0L10.5 8.8799L1.64226 0Z"
        fill={color}
      />
    </svg>
  );
}
